import React from 'react';
import LoadErrorScreen from './LoadErrorScreen';

export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('App render error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return <LoadErrorScreen onRetry={() => window.location.reload()} />;
    }
    return this.props.children;
  }
}
